export default __webpack_public_path__ + "static/media/create.eebc72cb.svg";